function sanitizeForCSVExport(str) {
  return str.replaceAll("#", "%23")
}

export default sanitizeForCSVExport